import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { CSSProperties, FC } from 'react';

interface IProps {
	onClick: () => void;
	disabled?: boolean;
	style?: CSSProperties;
}

export const AddButton: FC<IProps> = ({ onClick, disabled = false, style }) => (
	<Button {...{ type: 'primary', onClick, disabled, style }}>
		<div className='flex items-center'>
			<PlusOutlined style={{ marginRight: '0.3rem' }} /> Adicionar
		</div>
	</Button>
);
